import datepickerFactory from "jquery-datepicker";
import moment from "moment";

export function datepicker() {
    datepickerFactory(jQuery);
    let $datepicker = $("#datepicker");
    let $reportsHolder = $(".upcoming-reports-holder");
    let eventData = JSON.parse($datepicker.attr("data-event-list"));
    let curMonth = String(new Date()).slice(4, 7);

    let setEventLayoutData = function (date, desc) {

        return `<li class="upcoming-report">
            <h5>${date}</h5>
            <p>${desc}</p>
        </li>`;
    };

    $datepicker.datepicker({
        dayNamesMin: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ],
        minDate: "-6m + 2w",
        maxDate: "+11m + 2w",
        dateFormat: "MMM D YYYY",
        onChangeMonthYear: function () {
            $reportsHolder.empty(); // after changing month, empty the container with reports

            setTimeout(() => {
                curMonth = $(this).find(".ui-datepicker-month").text().slice(0, 3); // write to variable current month
            }, 300);
        },
        beforeShowDay: setEventDays
    });

    function setEventDays(date) {
        let curDate = moment(date).format("MMM D, YYYY");

        for (let i = 0; i < eventData.length; i++) {

            if (curDate === eventData[i].date) {
                setTimeout(() => {

                    if (curMonth === eventData[i].date.slice(0, 3)) { // using to exclude days outside of the current month
                        $reportsHolder.append(setEventLayoutData(eventData[i].date, eventData[i].eventDesc));
                    }
                }, 300);

                if (eventData[i].date !== (eventData[i + 1] && eventData[i + 1].date)) {
                    return [true, "ui-datepicker-unselectable"];
                }
            }
        }

        return [false];
    }

};


// WEBPACK FOOTER //
// ./assets/js/modules/datepicker.js